const getBaseUrlNative = (eUrl : string | undefined, ext : string | undefined) => {
  try {
      if (!eUrl) throw new Error("Error .")
      return ext ? eUrl+ext : eUrl;
  } catch (err) {
      console.log(err)
  }
}

export const urlBackNestApp :string = getBaseUrlNative(process.env.REACT_APP_HOST_API,'') as string || '';